<div class="popup-container">

    <div class="header text-middle roboto-medium">Select Columns</div>
  
    <div id="box">
      <label class="checkcontainer mt-3 ps-5">
        <input class="check" (change)="onSelectAllChange(selectAllCheckBox)" [(ngModel)]="selectAllCheckBox" id="up"
          type="checkbox" />
        <span class="checkmark ms-3"></span>SELECT ALL
      </label>
      <hr class="blue" />
      <div *ngFor="let item of preferenceList; index as i">
        <label class="checkcontainer ps-5 d-flex justify-content-between">
          <input type="checkbox" [(ngModel)]="item.checkVar" (change)="preferences(item)" class="check"/>{{item.colName}}
          <div class="pe-3 d-block">
          <img (click)="upImage($event,i)" *ngIf="i!=0" src="assets/images/icons8-up-24.png">
          <img (click)="downImage($event,i)" *ngIf="i!=preferenceList.length-1" src="assets/images/icons8-down-24.png">
        </div>
          <span class="checkmark ms-3"></span>
        </label>
        <hr class="blue" />
    </div>
    </div>
    <div class="right-align">
      <button (click)="resetClick()" id="cancel">RESET</button>
      <button (click)="getCheckedItems()" id="ok">SAVE</button>
    </div>
  
    <button mat-button mat-dialog-close (click)="onClmnOptCancel()" class="close black-button">
      X
    </button>
    
  </div>